<template>
  <div class="archives-content wrapper">
    <div v-if="content.items && content.items.length > 0">
      <ul class="archives-content__items">
        <li v-for="item in content.items" :key="item.title" ref="itemsElRef">
          <slot name="card" v-bind="{ item }">
            <Card :content="item"></Card>
          </slot>
        </li>
      </ul>

      <div class="archives-content__pagination mt-xxxl">
        <Pagination
          :origin="
            $route.params.sub
              ? `${currentUrl}/${$route.params.sub}/`
              : `${currentUrl}/`
          "
          :total="content.pages"
          :current="
            $route.params.pageNumber || $route.query.page
              ? parseInt(
                  ($route.params.pageNumber || $route.query.page) as string
                )
              : 1
          "
        />
      </div>
    </div>

    <div v-else>
      <h3>Aucun résultat</h3>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'

import Card from '@/components/cards/Default.vue'
import Pagination from '@/components/ui/Pagination.vue'

defineProps({
  content: {
    type: Object,
    required: true,
  },
})

const route = useRoute()
const getParent = ref()
const currentUrl = ref()

onMounted(() => {
  getParent.value = document.querySelector('.archives__grid')

  currentUrl.value = route.params.category
    ? `/${route.params.lang}/${route.params.segment}/${route.params.category}`
    : `/${route.params.lang}/${route.params.segment}`
})

watch(route, () => {
  if (getParent.value) {
    console.log('getParent.value', getParent.value)
    window.scrollTo({
      top: getParent.value.offsetTop - 150,
      behavior: 'smooth',
    })
  }
})
</script>

<style lang="scss" scoped>
.archives-content__items {
  @extend %list-nostyle;

  position: relative;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  row-gap: 3rem;

  @include mq(s) {
    grid-template-columns: repeat(4, 1fr);
    gap: 2rem;
    row-gap: 2rem;
  }

  @include mq(m) {
    gap: 0.8rem;
    row-gap: 8rem;
  }
}

.archives-content__pagination {
  display: flex;
  justify-content: center;
}
</style>
